module.exports = __webpack_public_path__ + "static/media/Image4.a355ddf4.png";